<div class="px-[60px] bg-[var(--lightBlue)] p-10 w-[80%] flex flex-col mx-auto rounded-lg">
    <span class="text-[#4D748D] text-[30px] pb-10">
        Minha área
    </span>
    <ul class="flex gap-10 flex-wrap" id="tools">
        <li routerLink="profile" routerLinkActive="text-red-700" [routerLinkActiveOptions]="{ exact: true }">
            <i class='bx bx-child'></i>
            <span>Seu Perfil</span>
        </li>

        <li routerLink="my-plan" routerLinkActive="text-red-700" [routerLinkActiveOptions]="{ exact: true }" class="hidden">
            <i class='bx bx-wallet-alt'></i>
            <span>Sua Assinatura</span>
        </li>

        <li routerLink="settings" routerLinkActive="text-red-700" [routerLinkActiveOptions]="{ exact: true }"
            id="settings">
            <i class='bx bx-cog'></i>
            <span>Configurações</span>
        </li>

        <li routerLink="my-statistics" routerLinkActive="text-red-700" [routerLinkActiveOptions]="{ exact: true }">
            <i class='bx bx-line-chart'></i>
            <span>Suas Estatistícas</span>
        </li>
    </ul>

</div>
<div class="w-[80%] mx-auto">
    <router-outlet></router-outlet>
</div>